export const stateOptions = [
  {
    name: 'Alabama',
    abbr: 'AL',
  },
  {
    name: 'Alaska',
    abbr: 'AK',
  },
  {
    name: 'Arizona',
    abbr: 'AZ',
  },
  {
    name: 'Arkansas',
    abbr: 'AR',
  },
  {
    name: 'California',
    abbr: 'CA',
  },
  {
    name: 'Colorado',
    abbr: 'CO',
  },
  {
    name: 'Connecticut',
    abbr: 'CT',
  },
  {
    name: 'Delaware',
    abbr: 'DE',
  },
  {
    name: 'Florida',
    abbr: 'FL',
  },
  {
    name: 'Georgia',
    abbr: 'GA',
  },
  {
    name: 'Hawaii',
    abbr: 'HI',
  },
  {
    name: 'Idaho',
    abbr: 'ID',
  },
  {
    name: 'Illinois',
    abbr: 'IL',
  },
  {
    name: 'Indiana',
    abbr: 'IN',
  },
  {
    name: 'Iowa',
    abbr: 'IA',
  },
  {
    name: 'Kansas',
    abbr: 'KS',
  },
  {
    name: 'Kentucky',
    abbr: 'KY',
  },
  {
    name: 'Louisiana',
    abbr: 'LA',
  },
  {
    name: 'Maine',
    abbr: 'ME',
  },
  {
    name: 'Maryland',
    abbr: 'MD',
  },
  {
    name: 'Massachusetts',
    abbr: 'MA',
  },
  {
    name: 'Michigan',
    abbr: 'MI',
  },
  {
    name: 'Minnesota',
    abbr: 'MN',
  },
  {
    name: 'Mississippi',
    abbr: 'MS',
  },
  {
    name: 'Missouri',
    abbr: 'MO',
  },
  {
    name: 'Montana',
    abbr: 'MT',
  },
  {
    name: 'Nebraska',
    abbr: 'NE',
  },
  {
    name: 'Nevada',
    abbr: 'NV',
  },
  {
    name: 'New Hampshire',
    abbr: 'NH',
  },
  {
    name: 'New Jersey',
    abbr: 'NJ',
  },
  {
    name: 'New Mexico',
    abbr: 'NM',
  },
  {
    name: 'New York',
    abbr: 'NY',
  },
  {
    name: 'North Carolina',
    abbr: 'NC',
  },
  {
    name: 'North Dakota',
    abbr: 'ND',
  },
  {
    name: 'Ohio',
    abbr: 'OH',
  },
  {
    name: 'Oklahoma',
    abbr: 'OK',
  },
  {
    name: 'Oregon',
    abbr: 'OR',
  },
  {
    name: 'Pennsylvania',
    abbr: 'PA',
  },
  {
    name: 'Rhode Island',
    abbr: 'RI',
  },
  {
    name: 'South Carolina',
    abbr: 'SC',
  },
  {
    name: 'South Dakota',
    abbr: 'SD',
  },
  {
    name: 'Tennessee',
    abbr: 'TN',
  },
  {
    name: 'Texas',
    abbr: 'TX',
  },
  {
    name: 'Utah',
    abbr: 'UT',
  },
  {
    name: 'Vermont',
    abbr: 'VT',
  },
  {
    name: 'Virginia',
    abbr: 'VA',
  },
  {
    name: 'Washington',
    abbr: 'WA',
  },
  {
    name: 'Washington, DC',
    abbr: 'DC',
  },
  {
    name: 'West Virginia',
    abbr: 'WV',
  },
  {
    name: 'Wisconsin',
    abbr: 'WI',
  },
  {
    name: 'Wyoming',
    abbr: 'WY',
  },
  {
    name: 'Puerto Rico',
    abbr: 'PR',
  },
  {
    name: 'Guam',
    abbr: 'GU',
  },
  {
    name: 'American Samoa',
    abbr: 'AS',
  },
  {
    name: 'U.S. Virgin Islands',
    abbr: 'VI',
  },
  {
    name: 'Northern Mariana Islands',
    abbr: 'MP',
  },
  {
    name: 'Marshall Islands',
    abbr: 'MH',
  },
  {
    name: 'Palau',
    abbr: 'PW',
  },
  {
    name: 'Federated States of Micronesia',
    abbr: 'FM',
  },
];

export const grossIncomes = [
  { label: 'Less than 25K', key: 2500000 },
  { label: '25K - 30K', key: 2750000 },
  { label: '30K - 40K', key: 3500000 },
  { label: '40K - 50K', key: 4500000 },
  { label: '50K - 60K', key: 5500000 },
  { label: '60K - 70K', key: 6500000 },
  { label: '70K - 80K', key: 7500000 },
  { label: '80K - 100K', key: 9000000 },
  { label: '100K - 125K', key: 11250000 },
  { label: '125K - 150K', key: 13750000 },
  { label: '150K - 200K', key: 17500000 },
  { label: '200K - 250K', key: 22500000 },
  { label: '250K - 350K', key: 27500000 },
  { label: '350K - 500K', key: 42500000 },
  { label: 'More than 500K', key: 50000000 },
  { label: 'Custom', key: null },
];

export const loanForgivenessOptions = [
  { label: 'Public Service Loan Forgiveness', key: 'PublicServiceLoanForgiveness' },
  { label: 'Teacher Loan Forgiveness', key: 'TeacherLoanForgiveness' },
  { label: 'Income-Driven Loan Forgiveness', key: 'IncomeDrivenLoanForgiveness' },
];

export default null;
